const DISCOUNT_RULES = {
  personal_3m: { months: 3, label: '9折' },
  personal_6m: { months: 6, label: '8折' },
  personal_12m: { months: 12, label: '7折' },
};

export const formatPrice = (cents) => {
  const value = Number(cents || 0) / 100;
  return value % 1 === 0 ? `${value}` : value.toFixed(2);
};

export const resolveDurationLabel = (days) => {
  const d = Number(days || 0);
  if (d >= 36500) return '终身';
  if (d === 3) return '3天';
  if (d === 30) return '1个月';
  if (d === 90) return '3个月';
  if (d === 180) return '6个月';
  if (d === 365) return '1年';
  if (d > 0) return `${d}天`;
  return '-';
};

export const formatPaymentAmount = (amountCents, currency = 'CNY') => {
  const amount = formatPrice(amountCents);
  if (String(currency || '').toUpperCase() === 'CNY') {
    return `¥${amount}`;
  }
  return `${currency} ${amount}`;
};

export const resolvePlanPricingMeta = (plan, monthlyBaseCents) => {
  const finalCents = Number(plan?.effective_price_cents ?? plan?.price_cents ?? 0);
  const originalFromBackend = Number(plan?.original_price_cents ?? plan?.price_cents ?? 0);
  const backendPromoLabel = String(plan?.promo_label || '').trim();
  const planId = String(plan?.plan_id || '').trim();
  if (originalFromBackend > 0 && finalCents > 0 && originalFromBackend > finalCents) {
    const savedCents = Math.max(originalFromBackend - finalCents, 0);
    return {
      hasDiscount: savedCents > 0,
      finalCents,
      originalCents: originalFromBackend,
      savedCents,
      discountLabel: backendPromoLabel,
    };
  }
  const rule = DISCOUNT_RULES[planId];
  if (!rule || !Number.isFinite(monthlyBaseCents) || monthlyBaseCents <= 0 || finalCents <= 0) {
    return {
      hasDiscount: false,
      finalCents,
      originalCents: finalCents,
      savedCents: 0,
      discountLabel: '',
    };
  }
  const originalCents = Math.max(Math.round(monthlyBaseCents * Number(rule.months || 0)), finalCents);
  const savedCents = Math.max(originalCents - finalCents, 0);
  return {
    hasDiscount: savedCents > 0,
    finalCents,
    originalCents,
    savedCents,
    discountLabel: String(rule.label || '').trim(),
  };
};

export const resolveLifetimeMeta = (plan, annualBaseCents) => {
  const planId = String(plan?.plan_id || '').trim();
  const isLifetime = planId === 'personal_lifetime' || Number(plan?.duration_days || 0) >= 36500;
  if (!isLifetime) {
    return {
      isLifetime: false,
      tagLabel: '',
      message: '',
    };
  }
  const finalCents = Number(plan?.effective_price_cents ?? plan?.price_cents ?? 0);
  const annualCents = Number(annualBaseCents || 0);
  const paybackYears = finalCents > 0 && annualCents > 0
    ? (finalCents / annualCents).toFixed(1)
    : '3.7';
  return {
    isLifetime: true,
    tagLabel: '长期最优',
    message: `约 ${paybackYears} 年回本，一次买断，持续使用越久越省`,
  };
};

export const resolveMonthlyBasePriceCents = (plans = []) => {
  const byId = (plans || []).find((plan) => String(plan?.plan_id || '').trim() === 'personal_1m');
  if (byId && Number(byId?.price_cents || 0) > 0) return Number(byId.price_cents);
  const byDuration = (plans || []).find((plan) => Number(plan?.duration_days || 0) === 30 && Number(plan?.price_cents || 0) > 0);
  if (byDuration) return Number(byDuration.price_cents);
  return 0;
};

export const resolveAnnualBasePriceCents = (plans = []) => {
  const byId = (plans || []).find((plan) => String(plan?.plan_id || '').trim() === 'personal_12m');
  if (byId && Number(byId?.price_cents || 0) > 0) return Number(byId.price_cents);
  const byDuration = (plans || []).find((plan) => Number(plan?.duration_days || 0) === 365 && Number(plan?.price_cents || 0) > 0);
  if (byDuration) return Number(byDuration.price_cents);
  return 0;
};
